"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../constants");
function getBrowserVendor() {
    try {
        return navigator.vendor || constants_1.UNAVAILABLE;
    }
    catch (error) {
        return constants_1.ERROR;
    }
}
exports.getBrowserVendor = getBrowserVendor;
